import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringJoin',
})
export class StringJoinPipe implements PipeTransform {
  transform(array: any[], property: string, delimitator: string = ', '): string {
    if (property && array?.length && array.some(a => a[property])) {
      return array
        .map(a => a[property])
        .filter(a => !!a)
        .join(delimitator);
    } else if (array?.length) {
      return array.join(delimitator);
    }

    return '';
  }
}
